"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromBearerHeader = void 0;
const fromBearerHeader = headerValue => {
  const PREFIX_LENGTH = 7;
  const prefix = "bearer ";
  if (headerValue.substring(0, PREFIX_LENGTH).toLowerCase() === prefix) {
    return headerValue.substring(PREFIX_LENGTH);
  }
  return "";
};
exports.fromBearerHeader = fromBearerHeader;
//# sourceMappingURL=bearer.js.map